import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import UserProgressModal from 'screens/UserProgress';
import { useFetchRecentPlaylistUsers } from 'actions/playlists';
import getFullUserName from 'utils/getFullUserName';
import getUserInspectorLink from 'utils/getUserInspectorLink';
import InlineStatsPanel from '.';
function formatRecentPlaylistUsersItem(item) {
  var _getFullUserName;
  var user = item.users;
  var name = (_getFullUserName = getFullUserName(user)) !== null && _getFullUserName !== void 0 ? _getFullUserName : user.name;
  return {
    icon: 'user',
    title: name,
    tooltip: user.name,
    extra: item.updated_time,
    value: "".concat(Math.round(item.completionRate * 100), "%"),
    link: getUserInspectorLink(user)
  };
}
function PlaylistRecentUsersStats(_ref) {
  var _ref$isPanelLayout = _ref.isPanelLayout,
    isPanelLayout = _ref$isPanelLayout === void 0 ? false : _ref$isPanelLayout,
    id = _ref.id,
    name = _ref.name;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasModal = _useState2[0],
    setHasModal = _useState2[1];
  var _useFetchRecentPlayli = useFetchRecentPlaylistUsers({
      contentId: id,
      showOnlyInactiveUsers: false
    }),
    items = _useFetchRecentPlayli.items,
    isLoading = _useFetchRecentPlayli.isLoading,
    isError = _useFetchRecentPlayli.isError;
  if (!items) return null;
  var formattedData = items.map(function (item) {
    return formatRecentPlaylistUsersItem(item);
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InlineStatsPanel, {
    isPanelLayout: isPanelLayout,
    title: t('analytics_user_progress'),
    data: formattedData,
    onClick: function onClick() {
      return setHasModal(true);
    },
    isLoading: isLoading,
    isError: isError
  }), hasModal && /*#__PURE__*/React.createElement(UserProgressModal, {
    id: id,
    name: name,
    onClose: function onClose() {
      return setHasModal(false);
    }
  }));
}
export default PlaylistRecentUsersStats;